export const subtitles = {
    "1": {
        "startTime": 16.71,
        "endTime": 23.72,
        "transcript": "Waten-wa tua uksuarmi cikuqerraarqami mamturivailegmi ciku aarnarqetulria.",
        "translation": "In the fall like this when it first freezes before it gets thick, the ice is dangerous."
    },
    "2": {
        "startTime": 23.72,
        "endTime": 31.13,
        "transcript": "Cali im' waten makut ilii qenunaciarluku qenunaciaraqluku.",
        "translation": "Also, part of it also freezes late like this."
    },
    "3": {
        "startTime": 33.42,
        "endTime": 39.74,
        "transcript": "Tua-i-w' nenglaiteqtaarqan cikunaciaraqluku, nengllingraan-llu cali ilii cikunaciaraqluku.",
        "translation": "When it repeatedly warms up, it freezes late, and even when it's cold, part of it freezes late."
    },
    "4": {
        "startTime": 39.795,
        "endTime": 46.855,
        "transcript": "Cali cikuqerqani cali tua-i aarnarqaqluni mamtuvkenani.",
        "translation": "Also, when it freezes, it's dangerously thin."
    },
    "5": {
        "startTime": 47.86,
        "endTime": 53.22,
        "transcript": "Naw'un tua-i yuum taringesciigataa mamkilnguq aarnarqelria-llu.",
        "translation": "A person has no means to understand thin and dangerous parts [of ice]."
    },
    "6": {
        "startTime": 53.405,
        "endTime": 64.035,
        "transcript": "Tau͡gaam ayarunqerquni ayarumikun tamaaggun cikuliur[utkun] ayarukun yuvriraqluku pikiniu nallunriciiqekii.",
        "translation": "But if he has a walking staff, if he examines that ice with his staff, he will know."
    },
    "7": {
        "startTime": 64.035,
        "endTime": 67.81,
        "transcript": "Ayagina'ar qanertuq ayaruq inerquutngullruniluku.",
        "translation": "Ayagina'ar said that the staff was part of an admonishment."
    },
    "8": {
        "startTime": 67.81,
        "endTime": 71.75,
        "transcript": "Yuut cikumek cuqyuteksuutekluku piitesqessuitellruit.",
        "translation": "They told people not to be without them to gauge the ice."
    },
    "9": {
        "startTime": 71.755,
        "endTime": 78.235,
        "transcript": "Waten cali qanrutetullruanga atama, yuut-wa tua-i allat-llu:",
        "translation": "My father used to tell me this, including other people:"
    },
    "10": {
        "startTime": 78.42,
        "endTime": 87.86,
        "transcript": "Waten alqunaq tua-i kiskan pugtakan, egmian tua-i tagesqevkenaku.",
        "translation": "If a one suddenly sinks like this and floats, they said not to go up to land right away."
    },
    "11": {
        "startTime": 87.865,
        "endTime": 90.965,
        "transcript": "Qamenritengnaqluku pisqelluku.",
        "translation": "They said to try to keep the ice from closing up."
    },
    "12": {
        "startTime": 91.57,
        "endTime": 99.16,
        "transcript": "Qamkuni tua-i egmian-llu nugengnaq'leryagluni pikuni imutun piniarciiquq.",
        "translation": "If it closes up and he tries to get out right away, he will become weakened."
    },
    "13": {
        "startTime": 99.24,
        "endTime": 101.37,
        "transcript": "Waten Ayagina'ar qanertuq:",
        "translation": "Ayagina'ar said this:"
    },
    "14": {
        "startTime": 101.37,
        "endTime": 108.97,
        "transcript": "\"Aliimaterluni yuk igeskuni, taukuk aliimetegni mecungarqaarluku nep'arcellukek cikum mengliinun.",
        "translation": "\"If a person has gloves as he falls [through the ice], he should wet his gloves and have them stick to the edge of the ice."
    },
    "15": {
        "startTime": 108.975,
        "endTime": 113.59,
        "transcript": "\"Tuaten pikuni nugyugngaciquq, irugni tau͡gaam ciumek nugglukek.",
        "translation": "\"If he does that, he can get out of the water, but he should take his legs out first."
    },
    "16": {
        "startTime": 113.59,
        "endTime": 115.18,
        "transcript": "\"Tua-i-llu nugkuni...\"",
        "translation": "\"Then when he gets out...\""
    },
    "17": {
        "startTime": 115.18,
        "endTime": 125.84,
        "transcript": "Waten, waten nengelmi waten-llu qanikcangvailgan nugkuni tua-i egmianun aturani yuulaagluki",
        "translation": "If he gets out in the cold like this before there is snow, he should take off his clothes right away"
    },
    "18": {
        "startTime": 125.845,
        "endTime": 129.295,
        "transcript": "Nuna canimelkan man'a, can'get-ll' alailkata.",
        "translation": "If the land here is close, and if grass if visible."
    },
    "19": {
        "startTime": 129.295,
        "endTime": 135.565,
        "transcript": "Ciulaagluki tua-i kumlalengraan, matarrluni tua-i yuulaagluki mecungelriit.",
        "translation": "Wring them out even if it's cold, undress and take off the wet clothes."
    },
    "20": {
        "startTime": 135.665,
        "endTime": 141.235,
        "transcript": "Ataam-llu all'uki, canegnek ekiirluku man' qaini.",
        "translation": "Then put them on again, putting a layer of grass against his skin."
    },
    "21": {
        "startTime": 142.265,
        "endTime": 147.445,
        "transcript": "Tua-i-llu nasperturluni qerrusngiinaqani",
        "translation": "Then he should make a considered decision if he is getting colder"
    },
    "22": {
        "startTime": 150.46,
        "endTime": 154.11,
        "transcript": "Qurrengnaqluki teq'uminek ellii meq'uni",
        "translation": "If he tries to urinate and drinks his own urine"
    },
    "23": {
        "startTime": 154.11,
        "endTime": 161.44,
        "transcript": "Elliin teq'uminek-wa tua-i kiimelkuni, wall' malruukunek aipami teq'urranek, qurrsugngalriim teq'urranek meq'uni",
        "translation": "His own urine if he's alone, or if there are two of him, his companion's urine, if he drinks the urine from one who can urinate"
    },
    "24": {
        "startTime": 161.44,
        "endTime": 164.53,
        "transcript": "Qerrungaituq-gguq tuaten tua-i yuk pikuni.",
        "translation": "They say a person will not freeze to death if he does that."
    },
    "25": {
        "startTime": 164.53,
        "endTime": 166.4,
        "transcript": "Ilagaqicikut unuaqu.",
        "translation": "Please join us tomorrow."
    },
    "26": {
        "startTime": 166.4,
        "endTime": 173.18,
        "transcript": "Ayaginaraam alerquaciqaikut yuut qaill' pillerkaitnek pellaakata waten allrakuq ellirluku ayuqaqan.",
        "translation": "Ayagina'ar will instruct us on what a person should do when lost when the [season of] the year is like this."
    },
    "27": {
        "startTime": 196.175,
        "endTime": 202.93,
        "transcript": "Makut ciulirneret makut qantulliniut ellaita atullmeggnek.",
        "translation": "These elders speak about things they've experienced."
    },
    "28": {
        "startTime": 202.93,
        "endTime": 214.89,
        "transcript": "Cali-ll' niitellmeggnek, ciulirnemeng au͡gkut cali qanellritnek niitellmeggnek qalarucitulliniut makunun ayagyuanun elluarrluki atuusqelluki, elluarrluku pillerkaatnek.",
        "translation": "They also speak about things they've heard, things they've heard their elders back then say, to young people so that they will be heeded correctly, and that they will go through life well."
    },
    "29": {
        "startTime": 214.895,
        "endTime": 221.73,
        "transcript": "Alerquutet makut yuum nallunrilkuniki, murilkelluki pikuniki ayagyuat makut",
        "translation": "If a person knows these traditional instructions, if these young people adhere to them"
    },
    "30": {
        "startTime": 221.73,
        "endTime": 227.06,
        "transcript": "Ayagyuat makut arcaqerluteng maa-i callerkarteng ilaita nalluat.",
        "translation": "Young people, especially today, do not know what they should do."
    },
    "31": {
        "startTime": 227.27,
        "endTime": 232.59,
        "transcript": "Taumek tamaa-i nallunritevkangnaqluki angayuqrita piarkauyaaqait.",
        "translation": "That's why their parents should let them know [of those things]."
    },
    "32": {
        "startTime": 232.595,
        "endTime": 237.395,
        "transcript": "Qalaruqu'urluki mat'um aarnarqellriim uum nalliini arcaqerluki.",
        "translation": "Always instruct them, especially in these current dangerous times."
    },
    "33": {
        "startTime": 237.395,
        "endTime": 239.625,
        "transcript": "Ayaginaraam qanellracetun",
        "translation": "As Ayagina'ar said"
    },
    "34": {
        "startTime": 239.625,
        "endTime": 247.375,
        "transcript": "Kuiget ilait mamturraarluteng mamkellilalliniut ella nenglairqaartelluku, cakneq aarnariqercelluki.",
        "translation": "After some river [ice] is thick, they get thin after the weather warms up, making them very dangerous."
    },
    "35": {
        "startTime": 247.375,
        "endTime": 251.525,
        "transcript": "Cali niiteqerlaut qaill' yuk pellaallakuni pillerkaanek.",
        "translation": "Let's also listen to what a person should do when suddenly lost."
    },
    "36": {
        "startTime": 251.525,
        "endTime": 261.915,
        "transcript": "Pellaakuni ellaqerruskani-llu, egmian cali ayagiinarpek'nani ayuquciireskuni arulairluni uitaurquni assinruciquq.",
        "translation": "If one gets lost and the weather gets back, it would be better if he doesn't continue, but stops right away and stays put."
    },
    "37": {
        "startTime": 261.915,
        "endTime": 265.39,
        "transcript": "Uitaurpek'nani-w' tua-i urumangnaqu'urluni tau͡gam nengelmi.",
        "translation": "Not staying still, but trying to stay warm in the cold."
    },
    "38": {
        "startTime": 265.39,
        "endTime": 274.47,
        "transcript": "Uitaurpek'nani aqumgaurpek'nani ellminek urumangnaqluni pikuni ayagiinarpek'nani arulair[luni].",
        "translation": "Not sitting still, trying to stay warm, and not continuing on but stopping [where he is]."
    },
    "39": {
        "startTime": 274.475,
        "endTime": 279.575,
        "transcript": "Imutun ayagiinaquni yaaqvanun tua-i ayagciquq, kiituan kaassairutuq.",
        "translation": "If he continues on, he will go far and eventually run out of gas."
    },
    "40": {
        "startTime": 279.98,
        "endTime": 285.33,
        "transcript": "Yuarastain-llu tua-i nalaqnaciarumaluku tuaten ayagallrukan.",
        "translation": "And those who look for him will not find him right away if he continues on like that."
    },
    "41": {
        "startTime": 285.37,
        "endTime": 296.28,
        "transcript": "Ayagankata kuigkun ayakatalriim nalluyagutevkenaki malikekiliki cikuliurutni, ayaruq, kangciraq, cali qanikciurutni.",
        "translation": "When they start traveling on [frozen] rivers, one who's going should not forget to take his ice pick, walking staff, tarpaulin, and his shovel."
    },
    "42": {
        "startTime": 296.28,
        "endTime": 305.92,
        "transcript": "Cali natmun ayakataquni qanrucugngayaaqekai ilani tamaatmun ayagciqniluni, natmun tuavet ayakatarniluni.",
        "translation": "Also, when he's going to travel, he can tell his family that he's going to that place, that he's going somewhere there."
    },
    "43": {
        "startTime": 306.575,
        "endTime": 315.415,
        "transcript": "Tua-i taukut kingunrin tekitellerkani pellukaku tua-i ayallra ciumek paqciiqaat tauna ullagyullra.",
        "translation": "If his expected return has passed, the people from his hometown will first go to where he wanted to go."
    },
    "44": {
        "startTime": 340.97,
        "endTime": 349.88,
        "transcript": "Ilait qenerrluteng waten tau͡ga kiumataqelriit taumeng caqerteḿeggneng tauna atuusqevkenaku",
        "translation": "Some angrily reply to whomever did [wrong] to them that they shouldn't do that"
    },
    "45": {
        "startTime": 350.22,
        "endTime": 354.35,
        "transcript": "Aturluku pisqevkenii, cuusqevkenii.",
        "translation": "That I shouldn't live my life doing that."
    },
    "46": {
        "startTime": 355.22,
        "endTime": 365.0,
        "transcript": "Nutaan cali arnaukan, nutaan tau͡ga kiuqeryugnaipallaarluku tauna qayilkuklua pikan",
        "translation": "Then if it's a woman, I should not reply harshly to her if she [?wrongs me]"
    },
    "47": {
        "startTime": 365.005,
        "endTime": 371.075,
        "transcript": "Kiuqeryugnaunaku ulurluku pisqellua.",
        "translation": "They told me not to reply harshly to her and turn away from her."
    },
    "48": {
        "startTime": 371.235,
        "endTime": 382.395,
        "transcript": "Tau͡ga-llu-gguq taum pitatma, wii pitatma pirrlainarpakaquma, pirrlainarpakaqanga tau͡gaten",
        "translation": "Then they said that if my age-mate, if my age-mate continually does that to me"
    },
    "49": {
        "startTime": 383.72,
        "endTime": 392.06,
        "transcript": "Naliak kinguvaralua, naliak-llu picuilkellua, kinguvaralua pikan",
        "translation": "If one puts my down, and if one says I'm a bad hunter, if he puts me down"
    },
    "50": {
        "startTime": 392.305,
        "endTime": 403.255,
        "transcript": "Qang'a-llu caitnilua naliatneng tayima piciqanga picuilkellua caitnilua-llu, carrlugaitnilua",
        "translation": "Or even if he says I have nothing, one may say I'm a bad hunter with nothing, not one single thing"
    },
    "51": {
        "startTime": 404.795,
        "endTime": 409.265,
        "transcript": "Arcauyaguskumteggu nutaan tauna kiusqelluku.",
        "translation": "They said to only reply if we can't take him anymore."
    },
    "52": {
        "startTime": 409.265,
        "endTime": 415.425,
        "transcript": "Piyugtacimtun kiusqelluku uum atama tau͡gaten alarquatullruanga.",
        "translation": "My father would instruct me like that, to answer however I want."
    },
    "53": {
        "startTime": 444.55,
        "endTime": 450.76,
        "transcript": "Au͡gkut angullrenka yuut Quyayaramek nallullrulriit.",
        "translation": "The people I was born in time to see back then didn't know about Thanksgiving."
    },
    "54": {
        "startTime": 450.76,
        "endTime": 455.84,
        "transcript": "Tua-i Quyayarartaunani maaten ellangua.",
        "translation": "In my earliest memories, I found that there was no Thanksgiving."
    },
    "55": {
        "startTime": 455.862,
        "endTime": 471.262,
        "transcript": "Nutaan tau͡gaam makunek Kuigilngurmi, pinek wani, agayulirteńek pingqelangamta nutaan Quyayaraq tamaani tamakut nasvallruat.",
        "translation": "ONly when there were you know, priests here in Kwigillingok, did they show how to celebrate Thanksgiving."
    },
    "56": {
        "startTime": 471.469,
        "endTime": 480.019,
        "transcript": "Ayagniqarraallra qanrutkellermeggni agayulirtet iliita, Didmer-aam pingatellrua",
        "translation": "When one of the priests talked about how it first started, I think it was Didmer"
    },
    "57": {
        "startTime": 480.951,
        "endTime": 492.813,
        "transcript": "Taukut-gguq teguarullret imarpiim akianek nani akmani yaaqvani, teguarullermeggnek imarpik qerarluku.",
        "translation": "He said that those captives from across the ocean, somewhere far away, they crossed the ocean in their captivity."
    },
    "58": {
        "startTime": 492.826,
        "endTime": 500.289,
        "transcript": "Imumek iciw' teguat makut teguarulriit assiliqapiarluteng piyuilnguut.",
        "translation": "You know, captives don't live very comfortable lives."
    },
    "59": {
        "startTime": 500.301,
        "endTime": 507.726,
        "transcript": "Arenqiallugtaarluteng pillruut, tua-i-llu imarpik tamana qerarluku.",
        "translation": "They had many hard times, then they crossed that ocean."
    },
    "60": {
        "startTime": 508.232,
        "endTime": 515.732,
        "transcript": "Cavkenateng tuc'ameng tamaani nutaan naucetaanek ayagnirluteng.",
        "translation": "Only when they had landed safely did they start planting crops."
    },
    "61": {
        "startTime": 516.651,
        "endTime": 522.651,
        "transcript": "Tamakut naucetaat ayagnilteng piluki.",
        "translation": "They [harvested] the crops they started planting."
    },
    "62": {
        "startTime": 522.67,
        "endTime": 536.258,
        "transcript": "Nutaan Quyayaraq tamana man'a maa-i ayagnillrulliniat Agayutmun iciw' aulukucirteng tamaani-llu qaillun teguarullermeggni nangteqellrung'e'rmeng cakneq.",
        "translation": "Then they started this Thanksgiving tradition here, you know, [in thanks] for God's care, though they had also been suffereing greatly when they were captives back then."
    },
    "63": {
        "startTime": 536.808,
        "endTime": 551.196,
        "transcript": "Tamakunek tamaa-i naucetaanek-ll' arcaqerluteng naugillermeggnek, Agayutem nauvkallrinek, neqkameggnek quyaluteng tamana, man'a maa-i Quyayaraq ayagnillruat nutaan.",
        "translation": "They started this Thanksgiving tradition especially in thanks for those crops that they grew, that God let grow for food."
    },
    "64": {
        "startTime": 576.621,
        "endTime": 589.209,
        "transcript": "Quyayaram nalliini tamakut pillermeggni, bring up-aallermeggni tamana, qanrutkellermeggni wangkutnun watua",
        "translation": "During Thanksgiving, when they [spoke of] those things, when they brought that up, when they told about it to us"
    },
    "65": {
        "startTime": 590.559,
        "endTime": 597.409,
        "transcript": "Nallunrirtainun mat'um Quyayaram quyatengqerrnarqelliniakut ellaicetun Agayutmun.",
        "translation": "To those who now of this Thanksgiving, we must be thankful to God as they were."
    },
    "66": {
        "startTime": 597.416,
        "endTime": 601.753,
        "transcript": "Iciw' cat tamalkuita quyatekarkaulliniluki.",
        "translation": "You know, we must be thankful for everything."
    },
    "67": {
        "startTime": 601.766,
        "endTime": 608.366,
        "transcript": "Maaten maa-i kinguakun umyuangcaulluku wii piaqa",
        "translation": "I realized afterwards when I thought about it"
    },
    "68": {
        "startTime": 608.385,
        "endTime": 617.948,
        "transcript": "Cat tamalkuita Agayutem aulukutai wangkutnun quyateknarqellinikput Agayutmun.",
        "translation": "We must be thankful to God for all of the ways that God takes care of us."
    },
    "69": {
        "startTime": 617.96,
        "endTime": 624.16,
        "transcript": "Maa-i arcaqerlua quyatengqertua mat'umi waniwa Quyayarami tekitellemteńi.",
        "translation": "I have one thing that I'm most thankful for as we've reached this Thanksgiving season."
    },
    "70": {
        "startTime": 624.454,
        "endTime": 637.254,
        "transcript": "Icivaq ava-i iraluni kiak August-aami ciungani naulluqrauratullruunga.",
        "translation": "Recently in the month of August this past summer, I would be sick before then."
    },
    "71": {
        "startTime": 637.273,
        "endTime": 641.473,
        "transcript": "Tua-i tunumnek piaqlua.",
        "translation": "I had back problems."
    },
    "72": {
        "startTime": 641.642,
        "endTime": 651.23,
        "transcript": "Tau͡gaam ava-i August-aaq pit'eqerluku nutaan naulluullruunga tamana anaggluku.",
        "translation": "But right when August became, I was more sick than ever before."
    },
    "73": {
        "startTime": 651.243,
        "endTime": 656.243,
        "transcript": "Qaika-llu mermek agtaraqluni, nuyanka-llu mermek piaqluteng.",
        "translation": "And my body would gush out sweat, and my hair would be soaked with sweat."
    },
    "74": {
        "startTime": 656.825,
        "endTime": 663.087,
        "transcript": "Cunawa teggalqunglliniama ilumkun qamaggun.",
        "translation": "It turned out it was because I had developed stones in my internal organs inside."
    },
    "75": {
        "startTime": 663.088,
        "endTime": 671.563,
        "transcript": "Tua-i nallunaitqapiarmek cirliqsartua hospital-aamun nataqiinrilkatnga taukunek.",
        "translation": "I would have undoubtedly incapacitated had they not found those in me at the hospital."
    },
    "76": {
        "startTime": 671.582,
        "endTime": 681.494,
        "transcript": "Waniwa tua-i tamana arcaqerluku quyatekaqa Agayutmun mat'um nalliini Quyayaram",
        "translation": "That is what I'm most thankful for to God during this Thanksgiving season"
    },
    "77": {
        "startTime": 681.507,
        "endTime": 692.507,
        "transcript": "Tuaten ayuqellrung'e'rma waniwa elliin man'a tekilluku, una tekilluku pivkaanga, unguvavkaanga.",
        "translation": "Because even though I was like that, he has allowed me to live to this time, this day."
    },
    "78": {
        "startTime": 718.514,
        "endTime": 724.801,
        "transcript": "Waten imkut qaneryaraat imkut teggenret maa-i aturtuq.",
        "translation": "We are now experiencing the traditional wisdom of those elders."
    },
    "79": {
        "startTime": 725.376,
        "endTime": 732.676,
        "transcript": "Waten kiagmi neqem nalliini neqkameng unangengnaqurasqaqkiikut.",
        "translation": "In the summer during fishing season like this, they tell us to try to catch fish."
    },
    "80": {
        "startTime": 732.695,
        "endTime": 741.22,
        "transcript": "Qanrulluta imkut civuliamta, qavaryugpegnata neqkameng unangengnaquraasqelluta.",
        "translation": "Our elders tell us not to sleep too much, but to try to catch fish."
    },
    "81": {
        "startTime": 741.226,
        "endTime": 744.726,
        "transcript": "Imarpik-gguq cacetuqutngunrituq.",
        "translation": "They said that the ocean is not dependable."
    },
    "82": {
        "startTime": 744.745,
        "endTime": 751.008,
        "transcript": "Tau͡ga cacetuqutngunritellni imarpiim tau͡ga elpecinun maa-i mania.",
        "translation": "Now, the ocean is showing you how undependable it is."
    },
    "83": {
        "startTime": 751.02,
        "endTime": 759.808,
        "transcript": "Waten tau͡gaam umgucimayungkunikut pissurciiganata umgucimaarkaugukut. Umgucimaarkaugaakut imarpiim.",
        "translation": "But if it wants to close it off to us, it will close off hunting for us. The ocean will close itself off to us."
    },
    "84": {
        "startTime": 760.683,
        "endTime": 773.008,
        "transcript": "Cali tau͡ga waten umyugartuarallemni, imkut cam iliini up'nerkaat, kiagucim iliini neqet enurnarqetuut.",
        "translation": "Also, when I ponder, fish are sometimes scarce in some spring seasons, some summers."
    },
    "85": {
        "startTime": 773.539,
        "endTime": 781.139,
        "transcript": "Cali tau͡ga imkut taqukat cali enurnaqluteng cam up'nerkaucim iliini.",
        "translation": "Also  those seals are scarce some spring seasons."
    },
    "86": {
        "startTime": 781.558,
        "endTime": 788.946,
        "transcript": "Cali imkut tengmiat makut ikgenateng up'nerkaucim iliini tekitnaurtut.",
        "translation": "Also, those birds would come in small numbers in some spring seasons."
    },
    "87": {
        "startTime": 789.084,
        "endTime": 798.021,
        "transcript": "Waten qanyuunateng nangniluki imkut. Nangniluki qanyuitellruut kitumun.",
        "translation": "They would say that there were none. They wouldn't tell anyone that there were none."
    },
    "88": {
        "startTime": 798.896,
        "endTime": 803.246,
        "transcript": "Tau͡gaam iliini atam, al'rrakuucim-ll' iliini",
        "translation": "But sometimes, you sees, and some years"
    },
    "89": {
        "startTime": 803.528,
        "endTime": 812.703,
        "transcript": "Imkut enurnaunateng pituut, neqet-ll' amllerrluteng, qang'a-ll' taqukat amllerrluteng, qang'a-llu tengmiat cali amllerraqluteng.",
        "translation": "Those would not be scarce, with lots of fish, and even lots of seals, and even lots of birds."
    },
    "90": {
        "startTime": 813.234,
        "endTime": 821.659,
        "transcript": "Tau͡gaten imumi ayuqellruut. Nangniluki tau͡gaten qanruteksuitelqait.",
        "translation": "That's what they were like long ago. They wouldn't say that there were none left like that."
    },
    "91": {
        "startTime": 850.39,
        "endTime": 858.165,
        "transcript": "Tan'gaurluq-gguq man'a arcaqerluni calligtetuuq pinariaqami.",
        "translation": "They say that a boy especially moves out when it is time for him."
    },
    "92": {
        "startTime": 858.184,
        "endTime": 864.796,
        "transcript": "Cali-llu-gguq amlleret, ilait amlleret, amllerni maa-i aturyaurrluku.",
        "translation": "They also said that many, some, many have started doing this now."
    },
    "93": {
        "startTime": 864.809,
        "endTime": 871.722,
        "transcript": "Iciw' nunalget nunalgutkenrilkeḿeggnek aipangaqluteng tan'gaurluut.",
        "translation": "You know, in villages, boys marry people who are not from the same village."
    },
    "94": {
        "startTime": 871.734,
        "endTime": 875.072,
        "transcript": "Nunalinqiggluteng apqiitnek au͡gkut ciuqlimta.",
        "translation": "They move to another village as our elders back then called it."
    },
    "95": {
        "startTime": 875.085,
        "endTime": 880.422,
        "transcript": "Tua-ll' tamana tamaa-i arcaqerluni qanruyun niitetulqa.",
        "translation": "Then there's that important traditional wisdom I used to hear."
    },
    "96": {
        "startTime": 881.097,
        "endTime": 891.397,
        "transcript": "Nunalinqigeskuni tan'gaurluq, tan'gaurlurni wangkuta, mat'umek arcaqerluta au͡gkut aarcirtullruitkut:",
        "translation": "If a boy moves to another village, we boys, this is what they especially warned us about back then:"
    },
    "97": {
        "startTime": 891.791,
        "endTime": 897.191,
        "transcript": "Nunalinqigeskumta-gguq nunakenrilkemteńun",
        "translation": "They said that if we move to another village that is not our own"
    },
    "98": {
        "startTime": 897.735,
        "endTime": 905.248,
        "transcript": "Tuani nunakenrilkemteńi ellangvikenrilkemteńi nunalinqigeskumta mulngakluta yuukilta.",
        "translation": "If we move to that village that is not our own where we grew up, we should live carefully."
    },
    "99": {
        "startTime": 905.26,
        "endTime": 914.135,
        "transcript": "Ukut nunat iciw' imumek nepliutekaatnek naucinritengnaqluta.",
        "translation": "You know, we should try not to sow discord in this village."
    },
    "100": {
        "startTime": 914.141,
        "endTime": 919.716,
        "transcript": "Iciw' [arcqerluku] man'a maa-i inerquutekellruat:",
        "translation": "You know, this is what they especially admonished against:"
    },
    "101": {
        "startTime": 919.735,
        "endTime": 933.747,
        "transcript": "Ilaten, ilavet, yuullgutvet, egilrallgutvet imumek nepliutekaatnek naucinritengnaqkina tamaani nunakenrilkevni.",
        "translation": "Do not try to sow discord among those around you, your fellow people who go through life with you, there where it's not your home village."
    },
    "102": {
        "startTime": 933.76,
        "endTime": 943.598,
        "transcript": "Atam-gguq tuaten tamana atunrilkuvgu, naucilaquvet nepliutekamek nunakenrilkevni",
        "translation": "Watch, they said, if you do not heed that, if you sow discord where it's not your home village"
    },
    "103": {
        "startTime": 943.611,
        "endTime": 947.273,
        "transcript": "Angayuqaagken yuarniaragket taukut nunat",
        "translation": "That village will wonder about your parents."
    },
    "104": {
        "startTime": 947.286,
        "endTime": 957.199,
        "transcript": "\"Qaillun qanruteksaitellruat-qaa tan'gaurluullrani angayuqranek?“",
        "translation": "\"How, has he not been instructed by his parents when he was a boy?\""
    },
    "105": {
        "startTime": 957.211,
        "endTime": 966.786,
        "transcript": "Nallumni-gguq aracqerluteng tamana qanrutkeciqaat naucitukuma nunakenrilkemni nepliutekaatnek.",
        "translation": "They said they will especially say that without my knowledge if I sow discord where it's not my home village."
    },
    "106": {
        "startTime": 994.005,
        "endTime": 1000.667,
        "transcript": "Tamatumek-llu maani ak'a qaneryaramek qanrucungramki qanrutesciiganaki",
        "translation": "And though I want to tell them about that traditional wisdom here, I cannot tell them"
    },
    "107": {
        "startTime": 1000.68,
        "endTime": 1008.768,
        "transcript": "Tua-i taringengailata tamatumek waten Yugtun, Kass'aturrlainaq qanngengameng makut watua.",
        "translation": "Because they won't understand Yup'ik like this since they only speak English now."
    },
    "108": {
        "startTime": 1011.781,
        "endTime": 1020.943,
        "transcript": "Tau͡gaam waten naw'un-wa maaggun taringecetaarturluku piurallrat assinruurtuq",
        "translation": "But it's better to give them examples or metaphors through these things"
    },
    "109": {
        "startTime": 1020.956,
        "endTime": 1029.694,
        "transcript": "Waten acirturluki-w' caluki anagulluki pissiyaagpek'naki.",
        "translation": "Not excessively naming them or whatever."
    },
    "110": {
        "startTime": 1029.707,
        "endTime": 1035.632,
        "transcript": "Umyugaat navgumalartuq pissiyaagluki piaqameng.",
        "translation": "Their minds are negatively affected when done excessively."
    },
    "111": {
        "startTime": 1069.463,
        "endTime": 1080.788,
        "transcript": "Taukut civunerkiutulit teggenrurtellriit makut taukuk cali nallunarikagneng cimiryuumarqulriarulutek",
        "translation": "Those elders who share wisdom about the future, if these two are not known anymore, they can be replaced"
    },
    "112": {
        "startTime": 1081.607,
        "endTime": 1087.219,
        "transcript": "Makuneng tan'gurrarneng civunerkiuritulit.",
        "translation": "Those who provide wisdom for the future to these boys."
    },
    "113": {
        "startTime": 1087.407,
        "endTime": 1099.707,
        "transcript": "Makut tau͡gken kevgaraat arnat enaitni, enmeggni amani marrlugaita tau͡gaam caliaqluki.",
        "translation": "But these girls who help out in their houses, their grandmothers work with them instead."
    },
    "114": {
        "startTime": 1099.714,
        "endTime": 1106.801,
        "transcript": "Cali taukugtun tua-i qaneryaraatun atauciuguq wii cumigartaqama.",
        "translation": "Their wisdom is one and the same with those two [old men] when I look closely."
    },
    "115": {
        "startTime": 1107.401,
        "endTime": 1119.551,
        "transcript": "Una-wa maurluqenricaaqeka-llu, anaanaka una taukuneng al'qamneng qanerturaqeraqan",
        "translation": "And though this wasn't my grandmother, when my maternal aunt instructed my older sisters"
    },
    "116": {
        "startTime": 1119.57,
        "endTime": 1126.195,
        "transcript": "Ayuqsarpigaqapiarluki iluarullutek, tau͡ga qaneryaraa tamana ayuqelliniuq.",
        "translation": "Being almost exactly the same, in conjuction, her traditional wisdom was the same."
    },
    "117": {
        "startTime": 1126.201,
        "endTime": 1134.089,
        "transcript": "Inerquutaat-ll' atauciuluni. Alarquuteklengnaaraat cal' atauciuluni.",
        "translation": "Their admonishments are one and the same. Their instructions are also one and the same."
    },
    "118": {
        "startTime": 1134.614,
        "endTime": 1140.177,
        "transcript": "Cameng alangaanarqelriameng qaneryarameng niitnarqevkenateng.",
        "translation": "You wouldn't hear any surprising [different] traditional wisdom."
    },
    "119": {
        "startTime": 1537.539,
        "endTime": 1544.852,
        "transcript": "Wangkuta avani maanicetun mikelngungellrunritukut canek teguyararkalirluta.",
        "translation": "We didn't have children like this a long time ago where things were readily available."
    },
    "120": {
        "startTime": 1544.864,
        "endTime": 1550.764,
        "transcript": "Maa-i maa-i-rpagminicetun pillrunritukut.",
        "translation": "We didn't do things like how they do it now."
    },
    "121": {
        "startTime": 1550.783,
        "endTime": 1559.821,
        "transcript": "Taug͡aam wangkuta qalarutestemta, qalarutestemta pisquciicetun mikelngiulallruukut.",
        "translation": "Instead, we took care of children as our instructors told us to."
    },
    "122": {
        "startTime": 1559.834,
        "endTime": 1565.859,
        "transcript": "Qavarput peggluku, qavarput arcaqakevkenaku.",
        "translation": "We forsook sleep; we didn't indulge in sleep."
    },
    "123": {
        "startTime": 1565.865,
        "endTime": 1574.94,
        "transcript": "Taumta-llu cali qanrucimacimcetun wangkutnek tau͡gaam aamarrluki, aamarterrlainarluki",
        "translation": "Then as we were told, we would only breastfeed them ourselves, only breastfeed them"
    },
    "124": {
        "startTime": 1574.959,
        "endTime": 1579.496,
        "transcript": "Kass'artarnek pisqevkenaki inerquumalallrucimcetun.",
        "translation": "As we were admonished against nursing them with Western bottles."
    },
    "125": {
        "startTime": 1580.796,
        "endTime": 1590.696,
        "transcript": "Tua-i-llu cali qavarput peggluku aulukesqumaciicetun maurluumteńek, anaanamteńek-llu wall'u",
        "translation": "Then as we were instructed to forsake sleep to take care of them by our grandmothers, or our maternal aunts"
    },
    "126": {
        "startTime": 1590.703,
        "endTime": 1599.015,
        "transcript": "Unugmi qava'arqamta, maa-i nallunritaci mikelnguyagaat cimiriuryaraugut.",
        "translation": "When we slept at night, you know that children's diapers need to be changed now."
    },
    "127": {
        "startTime": 1599.028,
        "endTime": 1602.553,
        "transcript": "Tau͡gaam wangkuta nallemteńi tuaten pinritukut.",
        "translation": "But we didn't do that in our time."
    },
    "128": {
        "startTime": 1602.572,
        "endTime": 1608.909,
        "transcript": "Tua-i qavarput peggluku pisquciicetun",
        "translation": "As they told us to forsake sleep"
    },
    "129": {
        "startTime": 1608.922,
        "endTime": 1619.934,
        "transcript": "Egmian qavaqackarraarluta caugaurqaarluki-llu qurreksaitelliniata qurruksuayagaitnun qurr'urtelluki wall' anartelluki.",
        "translation": "Right after we slept for a short time and turned to them, when they hadn't urinated, we would let them urinate or defecate into their little waste containers."
    },
    "130": {
        "startTime": 1619.947,
        "endTime": 1624.81,
        "transcript": "Terr'ilitanun, terr'ilitanek naanguartu'rpek'nata.",
        "translation": "We didn't have an easy time with diapers."
    },
    "131": {
        "startTime": 1624.822,
        "endTime": 1633.66,
        "transcript": "Tua-i-llu tang tuaten pimalriit aulukumalriit mikqapigteng'e'rmeng aulukut'seng elisngalaraat",
        "translation": "Then, you see, those who are taken care of like that know how they are taken care of though they are very small"
    },
    "132": {
        "startTime": 1633.673,
        "endTime": 1637.835,
        "transcript": "Ayagmek elpengqelaameng mikelnguyagaunge'rmeng.",
        "translation": "Because they're conscious form the start though they're small children."
    },
    "133": {
        "startTime": 1654.273,
        "endTime": 1660.898,
        "transcript": "Yagiraluki wall'u qanpagalluki anglicaasqevkenaki.",
        "translation": "They said not to raise your hand against them or shout at them when you raise them."
    },
    "134": {
        "startTime": 1660.904,
        "endTime": 1667.504,
        "transcript": "Tan'gaurluut arcaqerluki qanpagalluki pisqumanrit'lallruat waten qanerluteng:",
        "translation": "They especially said not to shout at boys, saying this:"
    },
    "135": {
        "startTime": 1667.523,
        "endTime": 1676.323,
        "transcript": "\"Pitsaqa'artevkenateng-gguq pissurnarikuneng, yuilqumi kiirrarmeng pingnatukuneng",
        "translation": "\"Should they reach the time when they start hunting, if they start to subsist by themselves in the wilderness"
    },
    "136": {
        "startTime": 1676.33,
        "endTime": 1681.642,
        "transcript": "\"Camek umyuameng alikarkaanek pitarkamek tangerquneng",
        "translation": "\"If they see an animal to hunt that their minds wil be afraid of"
    },
    "137": {
        "startTime": 1681.655,
        "endTime": 1686.055,
        "transcript": "\"Umyugailkararruteng-gguq iqlutmun qimagyuartut",
        "translation": "\"They might thoughtlessly flee the wong way"
    },
    "138": {
        "startTime": 1686.074,
        "endTime": 1693.349,
        "transcript": "\"Wall'u umyugailkararrluteng iqlutmun tauna pitarkaq pitaqengnaqnayukluku.\"",
        "translation": "\"Or they may thoughtlessly try to chase that animal the wrong way.\""
    },
    "139": {
        "startTime": 1693.355,
        "endTime": 1707.68,
        "transcript": "Tamana pitekluku inerquumalallruukut qancurlagalluki, irniaput qanpagalluki, wall' teguleraluki yagleraluki-llu anglicaasqumavkenaki.",
        "translation": "For that reason, we were admonished against raising children by shouting at them, shouting at our children, or physically grabbing and hitting them."
    },
    "140": {
        "startTime": 1731.836,
        "endTime": 1738.386,
        "transcript": "Nasaurluyagaat cali allakarmeng cali qanruyuterluteng cali anglicallrat.",
        "translation": "There are also separate pieces of traditional wisdom for raising little girls."
    },
    "141": {
        "startTime": 1738.393,
        "endTime": 1745.68,
        "transcript": "Tua-i cali au͡g'utun ayuquq, qancurlagatevkenaki yagleravkenaki-llu.",
        "translation": "It's like what I just said, not to shout or raise your hand against them."
    },
    "142": {
        "startTime": 1745.693,
        "endTime": 1752.355,
        "transcript": "Tau͡gaam kevkaurngata-gguq, wangkuta-gguq aanaulriani kevgarkaqngamteki",
        "translation": "But they said that because they will be helpers, since they will help those of us who are mothers"
    },
    "143": {
        "startTime": 1752.368,
        "endTime": 1756.668,
        "transcript": "Qanvallagavkenaki anglicararkaugaput.",
        "translation": "We must raise them without shouting at them."
    },
    "144": {
        "startTime": 1756.687,
        "endTime": 1768.412,
        "transcript": "Ayagmek-llu-gguq cauryaraq man' arnam tegulararallra tangvagceterrlainarluku, tangvagtelluku, elpekumavkarluku.",
        "translation": "And they said that from the start, have them watch how things are done, what women do, have them be conscious of them."
    },
    "145": {
        "startTime": 1768.418,
        "endTime": 1775.168,
        "transcript": "Tau͡gaam arenqiatuq ernerni makuni elitnauryaramun-llu mat'umun.",
        "translation": "But it's detrimental in these days [that they're] going to these schools."
    },
    "146": {
        "startTime": 1775.187,
        "endTime": 1784.037,
        "transcript": "Wiinga murilkurallemni, murilkurqapiarallemni, elitnauryaramun ek'aqameng ayuqucia cimiqalartuq.",
        "translation": "In my observation, my close observation, when they go to school, their behavior changes."
    },
    "147": {
        "startTime": 1784.044,
        "endTime": 1789.306,
        "transcript": "Maligtaquurautellrat-llu imna ikeggliinarluni.",
        "translation": "And they start becoming less and less obedient."
    },
    "148": {
        "startTime": 1789.319,
        "endTime": 1793.632,
        "transcript": "Kiituani ilii arturnariuq.",
        "translation": "Eventually, some become unmanageable."
    },
    "149": {
        "startTime": 1819.957,
        "endTime": 1826.519,
        "transcript": "Ilii aanairteng'e'rmi wall'u elliraqerteng'e'rmi",
        "translation": "Though some suddenly lose their mothers or become orphans"
    },
    "150": {
        "startTime": 1826.532,
        "endTime": 1832.72,
        "transcript": "Tua-i aanami caurallra napavkalaraa, alaitevkalaraa.",
        "translation": "They uphold what their mother did, and make it shown."
    },
    "151": {
        "startTime": 1832.733,
        "endTime": 1840.145,
        "transcript": "Tuaten cali elluarrluki cat pingnatugturluki, neqkat-llu uqlautenrilkurqurluki.",
        "translation": "They even strive do to things well, and they do not let their food become dirty."
    },
    "152": {
        "startTime": 1840.158,
        "endTime": 1846.933,
        "transcript": "Tamana tamaa-i wangkuta qaluruyutek'lallerput, qalaruyutekerrlainallerput.",
        "translation": "That was what we were told, what we were always told."
    },
    "153": {
        "startTime": 1846.939,
        "endTime": 1857.489,
        "transcript": "Arcaqerluta-llu iqulirrlainarluku cam iliini neqkaitellerkarput neqkat elluarrluki aulukeksailkumteki.",
        "translation": "They always ended it with the important fact that we would have no food someday if we don't take good care of food."
    },
    "154": {
        "startTime": 1857.558,
        "endTime": 1867.496,
        "transcript": "Neqkaitaarluki cali pivkaasqevkenaki pingnatamek ataita pingnatullrit elluarrluki aanaulriamun.",
        "translation": "They also said not to always be without food, for subsisting fathers to take care of those who are mothers."
    },
    "155": {
        "startTime": 1867.509,
        "endTime": 1874.534,
        "transcript": "Elluarrluki aulukesqumarrlainarluki, neryunarivkangnaqerrlainarluki-llu.",
        "translation": "They told them to always take good care of them, and always make them into edible food."
    }
};